import './gb-sayt-autocomplete.tag.html';
import './gb-sayt-categories.tag.html';
import './gb-sayt-divider.tag.html';
import './gb-sayt-link.tag.html';
import './gb-sayt-products.tag.html';
import './gb-sayt-refinements.tag.html';
import './gb-sayt-search-terms.tag.html';
import './gb-sayt.tag.html';



// WEBPACK FOOTER //
// ./~/source-map-loader!./src/tags/sayt/index.ts